var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasValidData)?_c('div',[_c('apexchart',{ref:"chart",attrs:{"type":"pie","height":_vm.height,"options":_vm.chartOptions,"series":_vm.validSeries}})],1):_c('div',{staticClass:"no-data-message"},[_c('p',[_vm._v("Nenhum dado disponível")])])}
var staticRenderFns = []

export { render, staticRenderFns }